import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Menu, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { KeyboardArrowDown } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { useState } from "react";
export const ChipWithMenu = ({ style, currentItem, setCurrentItem, menuPosition, menuItems, fontColor, fontWeight = 600 }) => {
    const [menuOpened, setMenuOpened] = useState(false);
    const [pendingItem, setPendingItem] = useState(null);
    const [opened, { open, close }] = useDisclosure(false);
    // This protects against the case where the currentItem is null/undefined
    // and the case where it defined, but it's attributes are not.
    const defaultStatus = {
        value: "Not Set",
        color: "var(--mantine-color-gray-4)",
        isClickable: true
    };
    const { value, color, isClickable } = currentItem
        ? {
            value: currentItem.value ?? defaultStatus.value,
            color: currentItem.color ?? defaultStatus.color,
            isClickable: currentItem.isClickable ?? defaultStatus.isClickable
        }
        : defaultStatus;
    const itemColor = fontColor ? fontColor : color;
    const handleClickItem = (item) => {
        setMenuOpened(false);
        if (item.setCurrentItemOnClick ?? true) {
            setCurrentItem(item);
        }
        item.onClick();
    };
    const handleUpdate = async () => {
        if (!pendingItem)
            return;
        setCurrentItem(pendingItem);
        pendingItem.onClick();
        setPendingItem(null);
        close();
    };
    const handleCancel = () => {
        setPendingItem(null);
        close();
    };
    const handleOpenMenu = () => {
        if (isClickable) {
            setMenuOpened(!menuOpened);
        }
    };
    return (_jsxs(Menu, { opened: menuOpened, onChange: handleOpenMenu, position: menuPosition ?? "right", offset: 1, withArrow: true, children: [_jsx(Menu.Target, { children: _jsxs(Flex, { style: {
                        backgroundColor: color,
                        color: itemColor,
                        fontWeight,
                        paddingLeft: "0.6rem",
                        borderRadius: "0.65rem",
                        width: "fit-content",
                        height: "fit-content",
                        display: "inline-flex",
                        whiteSpace: "nowrap",
                        alignItems: "center",
                        paddingRight: isClickable ? "0.3rem" : "0.6rem",
                        ...style
                    }, onClick: (event) => event.stopPropagation(), children: [_jsx("div", { children: value }), isClickable && (_jsx(SvgIcon, { component: KeyboardArrowDown, fontSize: "small", style: {
                                transform: menuOpened
                                    ? "rotate(-90deg)"
                                    : "rotate(0deg)",
                                transition: "transform 0.2s ease-in-out"
                            } }))] }) }), _jsxs(Menu.Dropdown, { style: { backgroundColor: "white" }, children: [_jsx(Text, { variant: "body", size: "sm", fw: 600, c: "var(--mantine-color-gray-5)", children: "Referral Stage" }), menuItems.map((item, index) => {
                        const itemColor = fontColor ? fontColor : item.color;
                        if (typeof item.visible === "boolean" && !item.visible)
                            return null;
                        return (_jsx(Menu.Item, { className: "grow-hover", style: {
                                backgroundColor: item.color,
                                color: itemColor,
                                fontWeight,
                                marginTop: "0.2rem",
                                height: "1.7rem"
                            }, disabled: !!item.disabled, onClick: (event) => {
                                handleClickItem(item);
                                event.stopPropagation();
                            }, children: _jsxs(Flex, { justify: "space-between", align: "center", style: { width: "100%" }, children: [_jsx("span", { children: item.value }), item.rightSection ? (_jsx("span", { style: {
                                            display: "inline-flex",
                                            marginLeft: "0.5rem"
                                        }, children: item.rightSection })) : null] }) }, index));
                    })] })] }));
};
